<template>
  <section class="base-page">
    <PageHeader class="base-shadow">
      <template #right>
        <el-button
          class="mt-r"
          size="small"
          type="primary"
          icon="el-icon-collection-tag"
          @click="navToTags"
          v-if="checkPermission(['ARTICLE_ADMIN'])"
          >标签管理</el-button
        >
        <el-button
          class="mt-r"
          size="small"
          type="primary"
          icon="el-icon-circle-plus"
          @click="showAsyncCreator = true"
          >从唯格云添加</el-button
        >
      </template>
    </PageHeader>
    <keep-alive><FilterSection @change="onFilterChange"/></keep-alive>
    <BasicTable
      showSelection
      :loading="tableLoading"
      :tableColumns="tableColumns"
      :tableData="tableData"
      :page="page"
      :size="size"
      :total="total"
      :orderDirection="orderDirection"
      :orderProp="orderProp"
      @onSortChange="onTableSortChange"
      @onSizeChange="handleSizeChange"
      @onPageChange="handlePageChange"
      @onRefresh="onRefresh"
      @onClearAndRefresh="onClearAndRefresh"
      @onSelectionChange="onSelectionChange"
    >
      <template #tableControl>
        <el-button
          size="small"
          class="mt-r"
          type="primary"
          icon="el-icon-document-add"
          @click="addRow"
          v-if="checkPermission(['PRODUCT_ADMIN'])"
          >新增</el-button
        >
        <el-checkbox class="mt-l mt-r" v-model="showDisable" @change="onSearch"
          >显示禁用</el-checkbox
        >
        &nbsp; &nbsp;
      </template>
      <template v-for="column in tableColumns">
        <el-table-column
          v-if="column.prop !== 'controlColumn' && column.showColumn"
          v-bind="column"
          :show-overflow-tooltip="true"
          :key="column.prop"
        >
          <template slot-scope="scope">
            <span v-if="column.prop === 'utc_create'">{{
              scope.row.utc_create | date_time
            }}</span>
            <span v-else-if="column.prop === 'utc_modified'">{{
              scope.row.utc_modified | date_time
            }}</span>
            <span v-else-if="column.prop === 'utc_post'">{{
              scope.row.utc_post | date_time
            }}</span>
            <span v-else-if="column.prop === 'disabled'">
              <el-tag
                :type="scope.row.disabled ? 'danger' : 'success'"
                @click="toggleDisableRow(scope.row, scope.$index)"
                >{{ scope.row.disabled ? "已禁用" : "已启用" }}</el-tag
              >
            </span>

            <span v-else-if="column.prop === 'vgc_article_id'">
              <span class="text-nav" @click="handleBindVgcArticle(scope.row)">{{
                scope.row.vgc_article_id == null
                  ? "点击绑定"
                  : scope.row.vgc_article_id
              }}</span>
            </span>
            <span v-else-if="column.prop === 'titleCn'">{{
              scope.row.title.cn
            }}</span>
            <span v-else-if="column.prop === 'titleEn'">{{
              scope.row.title.en
            }}</span>

            <span v-else-if="column.prop === 'description'">{{
              scope.row.description ? scope.row.description.cn : "/"
            }}</span>

            <span v-else-if="column.prop === 'content'">{{
              scope.row.content ? scope.row.content.cn : "/"
            }}</span>

            <el-image
              v-else-if="column.prop === 'poster_image_url'"
              style="width: 100%; height: 66px;"
              :src="scope.row.poster_image_url"
              :preview-src-list="posterImages"
            >
            </el-image>
            <el-image
              v-else-if="column.prop === 'description_image_url'"
              style="width: 100%; height: 66px;"
              :src="scope.row.description_image_url"
              :preview-src-list="descriptionImages"
            >
            </el-image>
            <span v-else-if="column.prop === 'tags'">
              {{
                scope.row.tags.length > 0
                  ? scope.row.tags.map((item) => item.name).join("、")
                  : "/"
              }}
            </span>

            <span v-else>{{ scope.row[column.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="column.prop === 'controlColumn' && column.showColumn"
          v-bind="column"
          :key="column.prop"
        >
          <template slot-scope="scope">
            <el-dropdown>
              <span class="el-dropdown-link drop-down-menu-link">
                更多操作<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-if="scope.row.canUpdate"
                  @click.native.prevent="editRow(scope.row, scope.$index)"
                  >编辑</el-dropdown-item
                >

                <el-dropdown-item
                  v-if="scope.row.canDisable"
                  :class="[scope.row.disabled ? 'text-success' : 'text-danger']"
                  @click.native.prevent="
                    toggleDisableRow(scope.row, scope.$index)
                  "
                >
                  {{ scope.row.disabled ? "启用" : "禁用" }}</el-dropdown-item
                >
                <el-dropdown-item
                  @click.native.prevent="handleBindVgcArticle(scope.row)"
                  >绑定唯格云文章</el-dropdown-item
                >
                <el-dropdown-item
                  @click.native.prevent="handleUpdateByVgcArticle(scope.row)"
                  >同步内容</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </template>
      <template #multipleControl>
        <el-button
          class="mt-r"
          size="small"
          @click="onMultipleToggleDisable(false)"
          :disabled="multipleSelected.length <= 0"
          >批量启用 {{ multipleSelected.length }}</el-button
        >
        <el-button
          class="mt-r"
          size="small"
          @click="onMultipleToggleDisable(true)"
          :disabled="multipleSelected.length <= 0"
          >批量禁用 {{ multipleSelected.length }}</el-button
        >
      </template>
    </BasicTable>
    <Form
      :show="formDialog"
      :sid="currentId"
      @cancel="onFormCancel"
      @success="onFormSuccess"
      @close="onFormClose"
    />
    <AsyncCreator :show="showAsyncCreator" @close="onAsyncCreatorClose" />

    <VgcArticlePikcer
      :show="showVgcArticlePicker"
      :query="bindQuery"
      @change="onVgcArticlePickerChange"
      @close="onVgcArticlePickerClose"
    />
  </section>
</template>

<script>
import BasicTable from "@/components/BasicTable";
import AsyncCreator from "./components/AsyncCreator.vue";
import VgcArticlePikcer from "./components/VgcArticlePikcer.vue";
import {
  GetArticleList,
  ToogleDisableByIds,
  PutArticle,
  GetDisableCheck,
  GetUpdateCheck,
} from "./api";
import PageHeader from "@/components/PageHeader";
import { ShowApiError } from "@/request/error";
import { isEmprty } from "@/utils/validate";
import { checkPermission } from "@/utils/auth";
import {
  GetTableOrderParams,
  onClearFilter,
  FormatMultipleItemIds,
  GetTableDisableMessage,
} from "@/utils/table";
import Form from "./components/Form";
import FilterSection from "./components/FilterSection";
import config from "@/config";
import table from "./mixins/table";
import form from "./mixins/form";
// import { buildI18nKeyValue } from "@/utils/common";
export default {
  name: "ArticlesList",
  components: {
    BasicTable,
    Form,
    FilterSection,
    PageHeader,
    AsyncCreator,
    VgcArticlePikcer,
  },
  mixins: [table, form],
  data() {
    return {
      showAsyncCreator: false,
      showVgcArticlePicker: false,
      formDialog: false,
      tableLoading: false,
      multipleFormDialog: false,
      tableColumns: [],
      page: 0,
      size: config.TABLE_SIZE,
      total: 0,
      tableData: [],
      tableFilters: {},
      orderProp: "utc_post",
      orderDirection: "descending",
      currentId: null,
      multipleSelected: [],
      showDisable: false,
      orderPropObj: {},
      bindDataItem: null,
      bindQuery: {
        title: "",
      },
    };
  },
  computed: {
    posterImages() {
      return this.tableData.map((item) => item.poster_image_url);
    },
    descriptionImages() {
      return this.tableData.map((item) => item.description_image_url);
    },
  },
  created() {
    this.buildTableColumns();
    this.getTableData();
  },
  methods: {
    isEmprty,
    checkPermission,
    handleBindVgcArticle(row) {
      this.bindDataItem = row;
      this.bindQuery = {
        title: row.title.cn,
      };
      this.showVgcArticlePicker = true;
    },
    handleUpdateByVgcArticle(row) {
      this.updateByVgcId(row);
    },
    async onVgcArticlePickerChange(data) {
      if (this.bindDataItem == null) {
        return;
      }
      let message = this.$message({
        message: "正在绑定...",
        type: "info",
        duration: 0,
        iconClass: "el-icon-loading",
      });
      try {
        let formData = this.buildFormByVgcItem(data[0]);
        console.log("选中的数据", data);
        // formData = this.buildFormByVgcItem(data);

        await PutArticle([
          {
            id: this.bindDataItem.id,
            ...formData,
          },
        ]);
        message.close();
        this.$message.success("绑定成功");
        this.bindDataItem = null;
        this.onVgcArticlePickerClose();
        this.getTableData();
      } catch (error) {
        message.close();
        ShowApiError("绑定失败", error);
      }
    },
    onVgcArticlePickerClose() {
      this.showVgcArticlePicker = false;
      this.bindQuery = {};
    },
    onAsyncCreatorClose() {
      this.showAsyncCreator = false;
      this.getTableData();
    },

    handleSizeChange(val) {
      this.page = 0;
      this.size = val;
      this.getTableData();
    },
    handlePageChange(val) {
      this.page = val - 1;
      this.getTableData();
    },

    onSearch() {
      this.page = 0;
      this.getTableData();
    },
    getTableData() {
      this.tableLoading = true;
      GetArticleList({
        page: this.page,
        size: this.size,
        sort: GetTableOrderParams(
          this.orderProp,
          this.orderDirection,
          this.orderPropObj
        ),
        disabled: this.showDisable,
        ...this.tableFilters,
      })
        .then((res) => {
          let { content, total_elements } = res.data;
          this.tableData = content;
          this.tableData = this.tableData.map((item) => {
            return {
              ...item,
              canUpdate: true,
              canDisable: true,
            };
          });
          this.onUpdateCheck();
          this.onDisableCheck();
          this.total = total_elements;
          this.bindDataItem = null;
          // 加载状态结束
          this.tableLoading = false;
        })
        .catch((err) => {
          this.tableLoading = false;
          ShowApiError("拉取列表错误", err);
        });
    },
    onRefresh() {
      this.getTableData();
    },
    onFilterChange(data) {
      this.tableFilters = { ...data };
      this.page = 0;
      this.onSearch();
    },
    onClearAndRefresh() {
      this.orderProp = "seq";
      this.orderDirection = "descending";
      this.onResetFilter();
    },
    onResetFilter() {
      this.tableFilters = onClearFilter(this.tableFilters);
      this.page = 0;
      this.onRefresh();
    },
    onTableSortChange({ prop, order }) {
      if (order === null) {
        this.orderProp = "seq";
        this.orderDirection = "descending";
      } else {
        this.orderProp = prop;
        this.orderDirection = order;
      }
      this.onRefresh();
    },
    addRow() {
      this.currentId = null;
      this.formDialog = true;
    },
    editRow(row) {
      if (!row.canUpdate) {
        this.$message.warning("没有权限执行此操作!");
        return false;
      }
      this.currentId = row.id;
      this.formDialog = true;
    },

    async onUpdateCheck() {
      try {
        let ids = this.tableData.map((item) => item.id);
        if (ids.length > 0) {
          let res = await GetUpdateCheck(ids);
          this.tableData = this.tableData.map((item) => {
            item.canUpdate = res.data;
            return item;
          });
        }
      } catch (error) {
        this.tableData = this.tableData.map((item) => {
          item.canUpdate = true;
          return item;
        });
      }
    },
    async onDisableCheck() {
      try {
        let ids = this.tableData.map((item) => item.id);
        if (ids.length > 0) {
          let res = await GetDisableCheck(ids);
          this.tableData = this.tableData.map((item) => {
            item.canDisable = res.data;
            return item;
          });
        }
      } catch (error) {
        this.tableData = this.tableData.map((item) => {
          item.canDisable = true;
          return item;
        });
      }
    },
    onFormClose() {
      this.formDialog = false;
      this.currentId = null;
    },
    onFormCancel() {
      this.formDialog = false;
      this.currentId = null;
      this.multipleFormDialog = false;
    },
    // 批量：启用/禁用
    onMultipleToggleDisable(flag = false) {
      if (this.multipleSelected.length <= 0) {
        return false;
      }
      let { ids, nameString, unableControl } = FormatMultipleItemIds({
        multipleSelectes: this.multipleSelected,
        nameKey: "nameCn",
      });
      let message = GetTableDisableMessage({
        total: this.multipleSelected.length,
        ableControlCount: ids.length,
        unableControlCount: unableControl.length,
        nameString: nameString,
        flag: flag,
        ableText: "启用",
        unAbleText: "禁用",
      });
      this.$msgbox({
        title: `${flag ? "禁用" : "启用"}提示`,
        message: message,
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (ids.length <= 0) {
              this.$message.info("无有效数据可操作");
              done();
              return;
            }
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "执行中...";
            ToogleDisableByIds(ids, flag)
              .then(() => {
                this.$message.success("操作成功");
                this.multipleSelected = [];
                this.onRefresh();
              })
              .catch((err) => {
                ShowApiError("操作请求错误", err);
              })
              .finally(() => {
                done();
                instance.confirmButtonLoading = false;
                instance.confirmButtonText = "";
              });
          } else {
            instance.confirmButtonLoading = false;
            instance.confirmButtonText = "";
            done();
          }
        },
      });
    },

    onSelectionChange(selections) {
      this.multipleSelected = selections;
    },
    toggleDisableRow(row, index) {
      if (row.canDisable) {
        ToogleDisableByIds([row.id], !row.disabled).then(() => {
          row.disabled = !row.disabled;
          this.$set(this.tableData, index, row);
          this.$message.success("操作成功!");
        });
      } else {
        this.$message.warning("没有权限执行此操作!");
      }
    },

    navToTags() {
      this.$router.push({
        name: "ArticleTagList",
      });
    },

    onFormSuccess() {
      if (isEmprty(this.currentId)) {
        this.page = 0;
      }
      this.onRefresh();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-image__inner {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .preview-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    &.contain {
      object-fit: contain;
    }
  }
}
</style>
<style lang="scss">
.series-file-list {
  width: 100%;
  .list-item {
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 10px 0;
    color: #4dbeff;
    cursor: pointer;
    overflow: hidden;
    border-bottom: 1px solid #f1f1f1;
    a {
      color: inherit;
    }
  }
}
</style>
